export const COMMAND_PARTICIPANT_STATS = "participant-stats";
